import styled, { css } from 'styled-components'

import { Carat, TypeStyle, fromMd, timingFast } from '@syconium/little-miss-figgy'

import { FIT_GUIDE_IMAGE_WIDTH } from './sizeChartData'
import { cellText, dataCellText, tableCell } from './styles'

export { Table } from './styles'

export const SectionBody = styled(TypeStyle.BodyDefault)`
  font-weight: 400;
`

export const SectionHeader = styled.div`
  align-items: center;
  display: flex;
  gap: ${o => o.theme.spacing(4)};
  justify-content: space-between;
`

export const ScrollControls = styled.div`
  display: none;

  ${fromMd} {
    display: flex;
    margin-inline-end: -${o => o.theme.spacing(1)};
  }
`

export const HorizontalScrollButton = styled.button`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  /* Grows the 16px carat to a 24px tap target */
  padding: ${o => o.theme.spacing(1)};
  transition: ${timingFast};

  &:disabled {
    color: ${o => o.theme.color.button.disabled.fill.on.background};
    cursor: default;
  }
`

export const HorizontalScrollButtonIcon = styled(Carat)`
  display: block;
`

export const FitGuideTableWrap = styled.div`
  margin-inline: -${o => o.theme.spacing(4)};
  overflow-x: auto;
  scroll-behavior: smooth;

  @media (prefers-reduced-motion: reduce) {
    scroll-behavior: auto;
  }

  &:focus-visible {
    outline: 2px solid ${o => o.theme.color.stroke.info.text.on.background};
    outline-offset: -2px;
  }

  ${fromMd} {
    margin-inline: -${o => o.theme.spacing(10)};

    /* The arrow nav replaces the scrollbar on desktop. */
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`

const fitGuideStartGutter = css`
  &:first-child {
    padding-inline-start: ${o => o.theme.spacing(4)};
  }

  ${fromMd} {
    &:first-child {
      padding-inline-start: ${o => o.theme.spacing(10)};
    }
  }
`

const fitGuideColumn = css`
  padding-inline: 0 ${o => o.theme.rowGap.extraSmall};
  white-space: normal;
  width: ${FIT_GUIDE_IMAGE_WIDTH}px;
`

export const ProductImageCell = styled.td`
  ${fitGuideColumn};
  vertical-align: bottom;
  ${fitGuideStartGutter};
`

export const ProductImageFrame = styled.div`
  width: ${FIT_GUIDE_IMAGE_WIDTH}px;

  img {
    border-radius: ${o => o.theme.borderRadius.sm};
  }
`

export const ProductHeaderCell = styled.th`
  ${cellText};
  color: ${o => o.theme.color.text.primary.on.background};
  font-weight: 700;
  padding-block: ${o => o.theme.spacing(6)};
  text-align: start;
  height: 68px;
  vertical-align: top;
  ${fitGuideColumn};
  ${fitGuideStartGutter};
`

export const FitGuideRow = styled.tr`
  &:nth-of-type(odd) {
    background-color: ${o => o.theme.color.fill.subtle};
  }
`

/**
 * Absorbs the table's leftover width so the product columns stay packed against the start edge
 * instead of spreading when there are too few products to fill the parent.
 */
export const SpacerCell = styled.td`
  padding: 0;
  width: 100%;
`

export const FitGuideCell = styled.td`
  ${tableCell};
  ${dataCellText};
  ${fitGuideColumn};
  ${fitGuideStartGutter};
`
